module.exports = __webpack_public_path__ + "static/media/Circle-on-new.a3f073af.svg";